import React from 'react';

const PageLoading: React.FC = () => {
  return <div className='empty-page-loader mx-auto top-1/2' />;
};

export default PageLoading;
